var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{staticClass:"ma-auto mc-max-width-100",attrs:{"outlined":"","width":"500","type":"warning"}},[_vm._v(" Пожалуйста, обратитесь в свою школу для получения актуальной ссылки на оплату. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }